import { render, staticRenderFns } from "./TimeslotDetalleForm.vue?vue&type=template&id=d60cefa4&"
import script from "./TimeslotDetalleForm.vue?vue&type=script&lang=js&"
export * from "./TimeslotDetalleForm.vue?vue&type=script&lang=js&"
import style0 from "./TimeslotDetalleForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TimeslotDetalleForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
